var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.target,"download":_vm.downloadName}},[_c('fa-icon',{attrs:{"icon":"file-download"}}),_vm._v(" "+_vm._s(_vm.title))],1)}
var staticRenderFns = []

export { render, staticRenderFns }